export default "__VITE_ASSET__0046ecb6__"